import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';
import {CANCELING_LEAVE_ACTION_TYPE_SUCCESS, CONFIRM_LEAVE_ACTION_TYPE, SHOW_UPCOMING_CHILDREN} from './action-types';

const State = Record({
    loadingChild: null,
    loadingDate: null,
    groupToFilter: null,
    showUpcomingChildren: false,
    childrenWithConfirmedLeave: [] as string[],
});

export default handleActions(
    {
        [Actions.confirming.type]: (state, {payload}) => {
            return state.merge({
                loadingChild: payload?.loadingChild,
                loadingDate: payload?.loadingDate,
            });
        },
        [Actions.confirmingSuccess.type]: state => {
            return state.merge({
                loadingChild: null,
                loadingDate: null,
            });
        },
        [Actions.confirmingFailed.type]: state => {
            return state.merge({
                loadingChild: null,
                loadingDate: null,
            });
        },
        [CONFIRM_LEAVE_ACTION_TYPE]: (state, {payload}) => {
            return state.merge({
                childrenWithConfirmedLeave: [
                    ...(state.childrenWithConfirmedLeave ?? []),
                    (payload as any).childId,
                ].filter(e => e),
                loadingChild: null,
                loadingDate: null,
            });
        },
        [CANCELING_LEAVE_ACTION_TYPE_SUCCESS]: (state, {payload}) => {
            return state.merge({
                childrenWithConfirmedLeave: (state.childrenWithConfirmedLeave ?? []).filter(
                    confirmedLeave => confirmedLeave !== (payload as any).childId,
                ),
                loadingChild: null,
                loadingDate: null,
            });
        },
        [SHOW_UPCOMING_CHILDREN]: state => {
            return state.merge({
                showUpcomingChildren: !state.showUpcomingChildren,
            });
        },
        [Actions.filterByBroup.type]: (state, {payload}) => {
            return state.merge({
                groupToFilter: payload?.groupToFilter,
            });
        },
    },
    new State(),
);
